var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546080"
    },
    d: "M215.28,428.139h169.719l-11.776-35.31H227.047L215.28,428.139z M397.243,445.794H203.036 c-2.834,0-5.5-1.359-7.159-3.663c-1.66-2.304-2.119-5.27-1.218-7.954l17.655-52.966c1.201-3.61,4.573-6.038,8.377-6.038h158.897 c3.796,0,7.168,2.428,8.377,6.038l17.655,52.966c0.892,2.684,0.441,5.65-1.218,7.954 C402.743,444.435,400.077,445.794,397.243,445.794L397.243,445.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546080"
    },
    d: "M503.172,445.794H61.793C27.719,445.794,0,418.067,0,384.001s27.719-61.793,61.793-61.793 c4.873,0,8.828,3.946,8.828,8.828s-3.955,8.828-8.828,8.828c-24.338,0-44.138,19.8-44.138,44.138s19.8,44.138,44.138,44.138 h441.379c4.873,0,8.828,3.946,8.828,8.828C512,441.848,508.045,445.794,503.172,445.794"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE3A2B"
    },
    d: "M185.379,313.38c0-23.049-19.165-41.746-42.116-43.935c-1.766-0.168-3.513-0.23-5.235-0.194 c-28.76,0.574-47.722,30.658-38.63,57.953l24.188,65.624h317.793l61.793-229.517c-90.642,0-165.226,65.907-175.378,153.83 c-1.501,13.03-12.791,22.722-25.909,22.722h-90.024C198.285,339.863,185.379,326.957,185.379,313.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#922C25"
    },
    d: "M432.552,295.725c0-14.627-11.855-26.483-26.483-26.483s-26.483,11.855-26.483,26.483 c0,14.627,11.855,26.483,26.483,26.483S432.552,310.353,432.552,295.725"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#922C25"
    },
    d: "M406.078,278.07c-0.662,0-1.324-0.071-1.995-0.221c-4.749-1.095-7.715-5.844-6.621-10.593 c5.87-25.406,17.699-37.182,42.222-41.984c4.749-0.927,9.419,2.172,10.355,6.965c0.936,4.785-2.18,9.419-6.965,10.355 c-17.708,3.478-24.082,9.905-28.398,28.637C413.731,275.316,410.094,278.07,406.078,278.07"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#922C25"
    },
    d: "M370.75,366.346c-4.131,0-7.83-2.913-8.651-7.133c-0.936-4.785,2.18-9.419,6.965-10.355 c17.708-3.478,24.082-9.905,28.398-28.637c1.103-4.758,5.853-7.724,10.593-6.621c4.749,1.095,7.715,5.844,6.621,10.593 c-5.87,25.406-17.699,37.182-42.222,41.984C371.88,366.293,371.315,366.346,370.75,366.346"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B8E4A"
    },
    d: "M317.793,163.311c-2.26,0-4.52-0.865-6.241-2.586l-35.31-35.31c-3.452-3.452-3.452-9.031,0-12.482 c3.452-3.452,9.031-3.452,12.482,0l35.31,35.31c3.452,3.452,3.452,9.031,0,12.482C322.313,162.446,320.053,163.311,317.793,163.311 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF9717"
    },
    d: "M406.069,119.174c-2.26,0-4.52-0.865-6.241-2.586l-35.31-35.31c-3.452-3.452-3.452-9.031,0-12.482 c3.452-3.452,9.031-3.452,12.482,0l35.31,35.31c3.452,3.452,3.452,9.031,0,12.482 C410.589,118.308,408.329,119.174,406.069,119.174"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF9717"
    },
    d: "M406.069,119.174c-2.26,0-4.52-0.865-6.241-2.586c-3.452-3.452-3.452-9.031,0-12.482l35.31-35.31 c3.452-3.452,9.031-3.452,12.482,0c3.452,3.452,3.452,9.031,0,12.482l-35.31,35.31 C410.589,118.308,408.329,119.174,406.069,119.174"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEC319"
    },
    d: "M184.381,304.553h36.308v-52.966c0-4.873-3.955-8.828-8.828-8.828h-52.966 c-4.873,0-8.828,3.955-8.828,8.828v19.138C166.964,274.866,180.717,287.904,184.381,304.553"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24AE5F"
    },
    d: "M379.586,168.336v-13.85c0-4.873-3.955-8.828-8.828-8.828H264.828c-4.873,0-8.828,3.955-8.828,8.828 v52.966h84.63C351.85,192.515,364.915,179.388,379.586,168.336"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#922C25"
    },
    d: "M300.138,304.553H184.382c0.627,2.851,0.998,5.791,0.998,8.828 c0,13.577,12.906,26.483,26.483,26.483h90.024c13.118,0,24.408-9.693,25.909-22.722c5.076-43.961,26.262-82.423,57.503-109.886 c7.812-6.868,16.252-13.047,25.229-18.45c8.969-5.411,18.485-10.046,28.434-13.824c9.949-3.778,20.33-6.691,31.064-8.669 c10.734-1.969,21.813-3.001,33.148-3.001v-35.31C399.607,128.001,317.096,198.622,300.138,304.553"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEC319"
    },
    d: "M379.587,168.335c25.344-19.085,55.296-32.026,88.276-37.411v-20.577 c0-4.873-3.955-8.828-8.828-8.828H353.104c-4.873,0-8.828,3.955-8.828,8.828v35.31h26.483c4.873,0,8.828,3.955,8.828,8.828V168.335 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CA1E9"
    },
    d: "M220.69,304.553h79.448c5.967-37.305,20.206-70.1,40.492-97.103H211.862 c-4.873,0-8.828,3.955-8.828,8.828v26.483h8.828c4.873,0,8.828,3.955,8.828,8.828V304.553z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#922C25"
    },
    d: "M141.241,322.208c0-4.882-3.955-8.828-8.828-8.828H98.048c-0.309,0-0.574,0.15-0.874,0.177 c0.044,4.529,0.715,9.119,2.225,13.647l1.412,3.831h31.603C137.287,331.036,141.241,327.09,141.241,322.208"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#922C25"
    },
    d: "M110.573,348.691c-1.077,0-2.074,0.256-3.028,0.609l6.276,17.046h27.418 c4.873,0,8.828-3.946,8.828-8.828c0-4.882-3.955-8.828-8.828-8.828H110.573z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSled);
export default __webpack_public_path__ + "static/media/sled.9744eeb07d5343c3d36dff4d13c6fc2e.svg";
export { ForwardRef as ReactComponent };